import type { ExternalConnectionViewModel, NetworkViewModel } from '@trinnvis/dabih-api-client';
import type { ComputerViewModelExtended } from './computer-view-model-extended';
import { isEmptyText } from './is-empty-text';
import { t } from 'src/i18n';

export function alertsForExternalConnections(
  c: ExternalConnectionViewModel,
  networks: (NetworkViewModel & { computers: ComputerViewModelExtended[]; alerts: string[] })[],
): string[] {
  const warnings: string[] = [];
  let connectedNetworkHasMedicalData = false;
  let typeName;
  for (const item1 of networks) {
    if (item1.uuid === c.networkUuid) {
      for (const item of item1.computers) {
        for (const element of item.personalDataItems) {
          if (element.type === 'medicalRecords' || element.type === 'medicalEquipmentRecords') {
            connectedNetworkHasMedicalData = true;
          }
        }
      }
    }
  }
  if (!c.networkUuid) {
    typeName = t('computers.externalConnectionAlerts.partnerDefinite');
    if (c.type === 'Hjemmekontor') {
      typeName = t('computers.externalConnectionAlerts.homeOfficeDefinite');
    }
    warnings.push(t('computers.externalConnectionAlerts.noNetworkRegistered', { typeName }));
  }
  if (c.connectionType !== 'NHN' && c.connectionType !== 'NHNotherISP' && connectedNetworkHasMedicalData) {
    typeName = t('computers.externalConnectionAlerts.partner');
    if (c.type === 'Hjemmekontor') {
      typeName = t('computers.externalConnectionAlerts.homeOffice');
    }
    warnings.push(t('computers.externalConnectionAlerts.mustConnectThroughHealthNetwork', { typeName }));
  }
  if (
    connectedNetworkHasMedicalData &&
    (!c.riskAssessments || c.riskAssessments.length < 1) &&
    (!c.otherRiskAssessments || c.otherRiskAssessments.length < 1)
  ) {
    // warnings.push('Det er ikke registrert noen risikovurderinger');
  }
  if (!c.riskAssessmentConcludesOk) {
    warnings.push(t('computers.externalConnectionAlerts.connectionMustBeRiskAssessed'));
  }
  if (c.type === 'Hjemmekontor' && isEmptyText(c.employeeUuid)) {
    warnings.push(t('computers.externalConnectionAlerts.missingPerson'));
  }

  if (c.type === 'Tilkoblet samarbeidspartner' && isEmptyText(c.partnerUuid)) {
    warnings.push(t('computers.externalConnectionAlerts.missingPartner'));
  }

  return warnings;
}
